import { render } from "./QuickAccessEditor.vue?vue&type=template&id=2dbd419e&scoped=true"
import script from "./QuickAccessEditor.vue?vue&type=script&lang=js"
export * from "./QuickAccessEditor.vue?vue&type=script&lang=js"

import "./QuickAccessEditor.vue?vue&type=style&index=0&id=2dbd419e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dbd419e"]])

export default __exports__